// extracted by mini-css-extract-plugin
export var btn = "B_mB y_tC y_td d_bz d_bP d_bD d_dw";
export var full = "B_vB d_w d_H";
export var hoverStyle = "B_mF";
export var zoom = "B_mG";